import { axiosService } from "./axiosService";

const ingredientApi = {
    getAllIngredient(params) {
        const url = '/ingredient';
        return axiosService.get(url, { params })
    },
    createIngredient(body) {
        const url = '/ingredient';
        return axiosService.post(url, body)
    },
    updateIngredient(id, body) {
        const url = `/ingredient/${id}`;
        return axiosService.put(url, body)
    },
    deleteIngredient(id) {
        const url = `/ingredient/${id}`;
        return axiosService.delete(url)
    },
}

export default ingredientApi;